/** @fileoverview Read-only account name and initials avatar shown at the right of the app top bar. */

import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';

type NameParts = { first_name?: string | null; last_name?: string | null; email?: string | null };

type Props = {
  user: NameParts & { picture?: string };
  name: string;
};

/** Returns the first letters of the first and last name, else the first letter of the email. */
export const initials = (user: NameParts) =>
  [user.first_name, user.last_name]
    .filter(Boolean)
    .map((name) => name?.trim().charAt(0).toUpperCase())
    .join('') ||
  user.email?.trim().charAt(0).toUpperCase() ||
  'U';

/** Shows a name with an initials avatar, without any menu. */
export default function AccountBadge({ user, name }: Props) {
  return (
    <div className="ml-auto flex h-9 items-center gap-2 px-1.5 text-sm font-semibold text-current">
      <span className="max-w-32 truncate">{name}</span>
      <Avatar size="sm">
        <AvatarImage src={user.picture} alt="" />
        <AvatarFallback className="bg-app-avatar font-semibold text-app-action-foreground">
          {initials(user)}
        </AvatarFallback>
      </Avatar>
    </div>
  );
}
